import { Injectable } from '@angular/core';
import {  ERROR_MESSAGES } from '../utility/error-messages';

@Injectable({
  providedIn: 'root'
})
export class ErrorValidationService {
  getErrorValidationMessage(formControlName: string, errors: [string, any][]): string {
    // console.log('errors', errors);
    for (let i = 0; i < errors.length; i++) {
      const [key, value] = errors[i];
      if (ERROR_MESSAGES[key]) {
        return ERROR_MESSAGES[key](formControlName, value);
      } 
    }

    return null;

  }

}
